import PageLayout from 'pages/Preview/PageLayout';
import PageProvider from 'pages/Preview/PageProvider';

const PreviewPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default PreviewPage;
